import style from './style.module.css';

export default function HR() {
	return <hr class={style.hr} />;
}
